<template>
  <div>
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="company">
            <el-input placeholder="请输入公司名称" v-model="searchForm.company" @keydown.enter.native="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="orderid">
            <el-input placeholder="请输入订单号" v-model="searchForm.orderid" @keydown.enter.native="handleSearchBtn" />
          </el-form-item>
          <el-form-item>
            <el-date-picker
              @keydown.enter.native="handleSearchBtn"
              v-model="searchForm.sendtime"
              type="datetimerange"
              range-separator="至"
              :picker-options="pickerOptions"
              @change="handleDateChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="zt">
            <el-select placeholder="审核状态" clearable v-model="searchForm.zt" @keydown.enter.native="handleSearchBtn">
              <el-option v-for="(item,index) in examineStatus" :key="index" :value="item.value" :label="item.label">{{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="kpzt">
            <el-select placeholder="开票状态" clearable v-model="searchForm.kpzt" @keydown.enter.native="handleSearchBtn">
              <el-option v-for="(item,index) in invoicingStatus" :key="index" :value="item.value" :label="item.label">{{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="fkzt">
            <el-select placeholder="付款状态" clearable v-model="searchForm.fkzt" @keydown.enter.native="handleSearchBtn">
              <el-option v-for="(item,index) in paymentStatus" :key="index" :value="item.value" :label="item.label">{{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn()" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn('searchForm')" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <div class="custom-table search-table">
      <el-button v-waves :loading="exportLoading" class="filter-item el-icon-download" type="success" size="small"
                 @click="handleExport">导出Excel
      </el-button>
      <BatchExamineContract @submit="handleExamineSubmit" :showBatchContract="showBatchContract" @update:showBatchContract="val => showBatchContract = val" :selectedIds="selectId"/>
      <BatchExamineKp @submit="handleExamineSubmit" :showBatchKp="showBatchKp" @update:showBatchKp="val => showBatchKp = val" :selectedIds="selectId"/>
      <BatchExaminePay @submit="handleExamineSubmit" :selectedIds="selectId"/>
      <el-table border fit highlight-current-row class="customer-table" :data="list" v-loading="listLoading" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <Expand :data="scope.row.childdata"/>
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="订单号" prop="orderid" width="160">
          <template #default="{ row }">
             <el-link type="primary" @click="handleShowOrder(row.childdata)" >{{ row.orderid }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="所属公司" prop="company" width="240"></el-table-column>
        <el-table-column label="负责人" prop="rname"></el-table-column>
        <el-table-column label="合同状态" prop="zt">
          <template v-slot="scope">
            <el-button :icon="scope.row.zt == '已审'?'el-icon-success':'el-icon-error'" :style="scope.row.zt == '已审'?'color:green':'color: red'" type="text" class="status_btn"/>
          </template>
        </el-table-column>
        <el-table-column label="开票状态" prop="kpzt">
          <template v-slot="scope">
            <span v-if="scope.row.kpzt == '未'">{{scope.row.kpzt}}</span>
            <el-button v-else :icon="scope.row.kpzt == '已开'?'el-icon-success':'el-icon-error'" type="text" :style="scope.row.kpzt == '已开'?'color:green':'color: red'" class="status_btn"/>
          </template>
        </el-table-column>
        <el-table-column label="付款状态" prop="fkzt">
          <template v-slot="scope">
            <el-button v-if="scope.row.fkzt === '已付' || scope.row.fkzt === '未付'" :icon="scope.row.fkzt == '已付'?'el-icon-success':'el-icon-error'" :style="scope.row.fkzt =='已付'?'color:green':'color: red'" type="text" class="status_btn"/>
            <span v-else>{{scope.row.fkzt}}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人" prop="lxr" width="120"></el-table-column>
        <el-table-column label="总价" prop="price" width="120"></el-table-column>
        <el-table-column label="签定时间" prop="sendtime" width="120"></el-table-column>
        <el-table-column label="操作" width="470" :fixed="getIsMobile?false:'right'">
          <template v-slot="scope">
            <el-button type="primary" size="small" @click="handleExamine({type:'single'},scope.row)"
                       class="el-icon-edit-outline"
            >
              审核
            </el-button>
            <el-button type="primary" size="small" @click="handleEdit(scope)"
                       class="el-icon-edit-outline" :disabled="scope.row.ow_type === 'F'"
            >
              编辑
            </el-button>
            <el-button type="primary" size="small" @click="handleOutboundOrder(scope)"
                       class="el-icon-edit-outline"
            >
              出库单
            </el-button>

            <el-button type="primary" size="small" @click="handlePrintContract(scope.row)"
                       class="el-icon-edit-outline"
            >
              打印合同
            </el-button>
            <el-popconfirm
              iconColor="red"
              @confirm="handleDelete(scope, scope.$index)"
              title="确认删除此条数据吗？"
            >
              <el-button slot="reference" size="small" class="el-icon-delete" type="danger" :disabled="scope.row.ow_type === 'F'">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                     :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                     :page-size="selectPage.pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                     style="margin-top: 14px;margin-bottom:14px"
      >
      </el-pagination>
    </div>
    <Edit :dialog="dialog" :form-data="editFormData" @submit="handleSubmit"
          @close="handleClose" :type="type" :submitLoading="submitLoading" />
    <Examine :examineDialog="examineDialog" @close="handleClose" @submit="handleExamineSubmit" :form-data="editFormData" :data="examine" :examineContract="examineContract"/>
     <el-dialog  :visible.sync="showContract"
                 title="修改合同"
                 :width="getIsMobile?'100%':'80%'"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 @close="handleClose"
                 class="contract-dialog">
       <Contract :data="editData" ref="contractRef"/>
       <el-tag class="contract-tag">
         <span type="primary" class="contract-link">总价：{{totalAmount}}</span>
       </el-tag>

       <div slot="footer" class="dialog-footer">
         <el-button @click="handleClose">取 消</el-button>
         <el-button type="primary" @click="handleEditSubmit" :loading="submitLoading">确 定</el-button>
       </div>
     </el-dialog>
    <el-dialog  :visible.sync="showOutboundOrder"
                title="出库单"
                :width="getIsMobile?'100%':'60%'"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                @close="handleClose"
                class="contract-dialog">
      <OutboundOrder :data="outboundOrder"  :id="contactId"/>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      title="订单"
      size="50%"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleCloseDrawer">
      <Order :data="orderData"/>
    </el-drawer>
  </div>
</template>
<script>
import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref,watchEffect } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import Edit from './edit.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'
import waves from '@/directive/waves'
import Expand from './expand.vue'
import Examine from './examine.vue'
import Contract from '@/views/createContract/model.vue'
import OutboundOrder from './outboundOrder.vue'
import Order from './order.vue'
import { getToken } from '@/utils/auth'
import useRootSetting from '@/hooks/useRootSetting'
import BatchExamineContract from "./batchExamineContract.vue"
import BatchExamineKp from "./batchExamineKp.vue"
import BatchExaminePay from "./batchExaminePay.vue"

export default defineComponent({
  components: { PageWrapper, Edit, Expand,Examine,Contract,OutboundOrder,Order,BatchExamineContract,BatchExamineKp,BatchExaminePay},
  directives: { waves },
  setup() {
    const { getIsMobile } = useRootSetting()
    const instance = getCurrentInstance()
    const userName = instance.proxy.$store.getters.name
    const searchFormRef = ref(null)
    const searchForm = reactive({
      company: '',
      orderid: '',
      zt: '',
      kpzt: '',
      fkzt:'',
      sendtime:[]
    })
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref('')
    const editFormData = ref({})
    const list = ref([])
    const listLoading = ref(false)
    const untaxedAmount = ref(0)
    const taxedAmount = ref(0)
    const exportLoading = ref(false)
    const keyId = ref(0)
    const submitLoading = ref(false)
    const examineDialog = ref(false) //修改合同状态
    const showContract = ref(false) //修改合同
    const showOutboundOrder = ref(false) //出库单
    const examine = ref({}) //审核数据
    const examineContract = ref('')//用于标识审核弹窗的合同字段是否显示
    const examineId = ref(0)
    const editData = reactive({row:{}})
    const contractRef = ref(null)
    const totalAmount = ref(0)
    const drawer = ref(false)
    const showBatchContract = ref(false) //显示批量弹窗
    const showBatchKp = ref(false)

    const examineStatus = ref([
      {
        label: '已审',
        value: 1
      },
      {
        label: '未审',
        value: 0
      }
    ])
    const invoicingStatus = ref([
      {
        label: '已开',
        value: 1
      },
      {
        label: '未开',
        value: 0
      },
      {
        label: '未',
        value: 2
      }
    ])
    const paymentStatus = ref([
      {
        label: '已付',
        value: 1
      },
      {
        label: '未付',
        value: 0
      },
      {
        label: '未清',
        value: 2
      }
    ])

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const getContract = () => {
      listLoading.value = true
      request({
        url: 'customer_contract_list.yy',
        method: 'post',
        params: selectPage,
        data:{...searchForm,...{username:userName}}
      }).then(res => {
        const { code,data,total,qz } = res
        if (code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
          examineContract.value = qz
        }
      })
    }

    onMounted(() => {
      getContract()
    })


    const handleAdd = () => {
      dialog.value = true
      type.value = 'add'
      editFormData.value = {}
    }
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getContract()

    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getContract()
    }

    const handleEdit = ({ row }) => {
      showContract.value = true
      editData.row = row
    }
    //审核提交
    const handleExamineSubmit = (form,type) => {
      submitLoading.value = true
      request({
        url: 'contract_review.yy',
        method: 'post',
        data: {id: type === 'batch' ? selectId.value : examineId.value,...form},
      }).then(res => {
        if(res.code == 200) {
          submitLoading.value = false
          examineDialog.value = false
          showBatchContract.value = false
          showBatchKp.value = false
          getContract()
        }
      })
    }
    //合同修改提交
    const handleEditSubmit = () => {
      const fid = contractRef.value.fid
      const childdata = contractRef.value.modelList
      const kpzt = contractRef.value.hs
      const a1 = contractRef.value.editorContent
      request({
        url: 'contract_update.yy',
        method: 'post',
        data: {fid: fid,kpzt: kpzt,a1: a1,childdata: childdata},
      }).then(res => {
        if(res.code == 200) {
          showContract.value = false
          getContract()
        }
      })
    }

    const handleClose = () => {
      dialog.value = false
      showContract.value = false
      showOutboundOrder.value = false
      examineDialog.value = false
      editFormData.value = {}
      showBatchContract.value = false
      showBatchKp.value = false
    }
    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getContract()
    }

    const handleResetBtn = (formName) => {
      searchFormRef.value.resetFields()
      getContract()
    }

    const handleDelete = (scope, index) => {
      request({
        url: 'contract_delete.yy',
        method: 'post',
        data: { id: scope.row.id }
      }).then(res => {
        if (res.code == 200) deleteRow(index)
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }

    const deleteRow = (index) => {
      list.value.splice(index, 1)
    }


    //导出主列表及子列表
    const formatJson = (data,mainFields, childFields) => {
      const newList = JSON.parse(JSON.stringify(data));
      return newList.flatMap(v => {
        const mainRow = mainFields.map(j => v[j] || "");
        const childRows = v.childdata?.map(child => {
          return mainFields.map(() => "")
            .concat(childFields.map(j => child[j] || ""));
        }) || [];
        return [mainRow, ...childRows];
      });
    };
    const handleExport = () => {
      exportLoading.value = true
      if(searchForm.sendtime.length === 0) {
        exportLoading.value = false
        Message.error('必须选择时间范围，且范围最多是一年才可导出！')
        return
      }
      request({
        url: 'customer_contract_download.yy',
        method: 'post',
        data:{...searchForm,...{username:userName}}
      }).then(res => {
        if(res.code == 200) {
          import('@/vendor/Export2Excel').then(excel => {
            const tHeader = ['id', '订单号', '所属公司', '负责人', '合同状态', '开票状态', '付款状态',
              '联系人', '总价', '签订时间','cid','型号','品牌','数量','单价','总价'
            ]
            const filterVal = ['id', 'orderid', 'company', 'rname', 'zt', 'kpzt',
              'fkzt', 'lxr', 'price', 'sendtime'
            ]

            const childFilterVal = ["cid", "xhname", "source","num","price","zprice"];

            const data = formatJson(res.data,filterVal,childFilterVal)
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '合同报表'
            })
            exportLoading.value = false
          })
        }
      })
    }


    const handleExamine = ({type},row) => {
      if(type === 'single') {
        examineDialog.value = true
        examine.value = row
        examineId.value = row.id
      }
    }

    const outboundOrder = ref({})
    const contactId = ref(0)
    const handleOutboundOrder = ({row}) => {
      showOutboundOrder.value = true
      outboundOrder.value = row
      contactId.value = row.cid
    }

    watchEffect(() => {
      if (contractRef.value) {
        totalAmount.value = contractRef.value.totalAmount;
      }
    });
    const handleSubmit = () => {}

    //打印合同
    const handlePrintContract = ({ id }) => {
      const baseUrl = process.env.VUE_APP_BASE_API
      const url = 'print_contract.yy'
      const token = getToken()
      window.open(`${baseUrl}/${url}?id=${id}&token=${token}`)
    }

    const handleCloseDrawer = () => {
      drawer.value = false
    }

    const orderData = ref([])
    const handleShowOrder = (data) => {
      drawer.value = true
      orderData.value = data
    }


// 存储开始时间和一年后的时间
    const startTime = ref(null)
    const oneYearLater = ref(null)

    const pickerOptions = computed(() => ({
      onPick: ({ maxDate, minDate }) => {
        // 当用户选择了第一个日期时触发
        if (minDate && !maxDate) {
          startTime.value = minDate.getTime()
          const date = new Date(minDate)
          oneYearLater.value = new Date(date.setFullYear(date.getFullYear() + 1))
        }
      },
      disabledDate: (time) => {
        // 如果没有选择开始日期，不禁用任何日期
        if (!startTime.value) return false

        // 禁用开始日期之前的日期和一年后的日期
        return (
          time.getTime() < startTime.value ||
          time.getTime() > oneYearLater.value.getTime()
        )
      }
    }))

    const handleDateChange = (val) => {
      // 当日期范围改变时，重置限制条件
      if (!val || val.length === 0) {
        startTime.value = null
        oneYearLater.value = null
      }
    }

    //批量选中的值
    const selectId = ref(0)
    const handleSelectionChange = (val) => {
      selectId.value = val.map(item => item.id)
    }

    return {
      showBatchContract,
      showBatchKp,
      selectId,
      orderData,
      drawer,
      getIsMobile,
      contactId,
      outboundOrder,
      totalAmount,
      contractRef,
      editData,
      examineId,
      examine,
      userName,
      keyId,
      list,
      searchForm,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      exportLoading,
      listLoading,
      untaxedAmount,
      taxedAmount,
      searchFormRef,
      submitLoading,
      invoicingStatus,
      paymentStatus,
      examineStatus,
      examineDialog,
      showContract,
      showOutboundOrder,
      examineContract,
      pickerOptions,
      handleSelectionChange,
      handleDateChange,
      handleShowOrder,
      handleCloseDrawer,
      handlePrintContract,
      handleSubmit,
      handleEditSubmit,
      handleExamineSubmit,
      handleOutboundOrder,
      handleExamine,
      handleExport,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleClose,
      closeSearch,
      handleSearchBtn,
      handleResetBtn,
      handleEdit,
      handleDelete,
      deleteRow

    }
  }
})
</script>
<style scoped>
.el-icon-delete {
  margin-left: 4px;
  span {
    margin-left: 4px;
  }
}

.el-icon-download {
  margin-bottom: 10px
}

.contract-dialog {
  .contract-tag {
    position: absolute;
    right: 0;
    top:70px;
  }
}
.status_btn {
  font-size: 20px;
}
</style>
